import axios from "axios";
import { socket } from "../../socket";

export const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const path = "api/v1/user/login";
  const response = await axios.post(path, {
    email,
    password,
  });
  const { accessToken } = response.data.responseData;
  localStorage.setItem("accessToken", accessToken);
};

export const fetchMe = () => {
  let accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    return axios
      .get("api/v1/user/me", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        return response.data.responseData;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  } else {
    return null;
  }
};

export const logout = () => {
  //TODO -> Need to add more logic.
  localStorage.clear(); //Clears all the data from localstorage once the user logsout of the app.
  window.location.replace("/login");

  socket.disconnect();
};
